import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type RecurringExpensesViewMode = 'table' | 'list' | 'cards' | 'grouped';

interface RecurringExpensesUiState {
  view: RecurringExpensesViewMode;
  setView: (view: RecurringExpensesViewMode) => void;
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useRecurringExpensesUi = create<RecurringExpensesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.recurring-expenses:ui',
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
